import { render } from "./AdminButtonBar.vue?vue&type=template&id=1cd15bf3"
import script from "./AdminButtonBar.vue?vue&type=script&lang=js"
export * from "./AdminButtonBar.vue?vue&type=script&lang=js"

import "./AdminButtonBar.vue?vue&type=style&index=0&id=1cd15bf3&lang=css"
script.render = render

export default script